import { defineComponent, h, useAttrs } from 'vue'
import { VMenu } from 'vuetify/components'

VMenu.compatConfig = {
  ...(VMenu.compatConfig || {}),
  COMPONENT_V_MODEL: false
}

function isEventKey(key) {
  return /^on[A-Z]/.test(key)
}

function toLegacyOnKey(key) {
  return key.slice(2).toLowerCase()
}

function splitActivatorProps(props = {}) {
  const attrs = {}
  const on = {}

  Object.entries(props).forEach(([key, value]) => {
    if (isEventKey(key)) {
      on[toLegacyOnKey(key)] = value
    } else {
      attrs[key] = value
    }
  })

  return { attrs, on }
}

export default defineComponent({
  name: 'VMenuCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () =>
      h(VMenu, attrs, {
        ...slots,
        activator: slots.activator
          ? (scope) => {
              const { attrs: legacyAttrs, on } = splitActivatorProps(
                scope?.props || {}
              )

              return slots.activator({
                ...scope,
                attrs: legacyAttrs,
                on
              })
            }
          : undefined
      })
  }
})
